export default __webpack_public_path__ + "static/CorprateHp-slider-m-27a0be679e7ed29aabdd1a019d07aaf0.gif";